import { action, observable, makeObservable } from 'mobx';
import {contentLoaders, SuccessResponse, X7PushableBlockUpdateModel} from '../../../../domain';
import {HttpPromiseState, SaveStateHolder, StringControl, validators} from '../../../../lib/helpers';

export class AddPushableBlockStore implements SaveStateHolder {
  name: StringControl;

  @observable.ref
  save: HttpPromiseState<SuccessResponse> | null;

  constructor(readonly pageId: number) {
    makeObservable(this);
    this.name = new StringControl('name', '', validators.required);
    this.save = null;
  }

  @action
  complete() {
    if (this.save?.isPending === true)
      return;
    this.name.markTouched();
    if (this.name.invalid)
      return;
    const model: X7PushableBlockUpdateModel = {
      PageId: this.pageId,
      Name: this.name.value
    };
    this.save = contentLoaders.x7pushableBlock.insert(model);
  }
}
